import { render } from "./create-shop.vue?vue&type=template&id=e2f67a14&scoped=true&ts=true"
import script from "./create-shop.vue?vue&type=script&lang=ts"
export * from "./create-shop.vue?vue&type=script&lang=ts"

import "./create-shop.vue?vue&type=style&index=0&id=e2f67a14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f67a14"]])

export default __exports__